import { DOUBLE_DASH } from 'consts/placeholders';
import Timeline, { TimelineItem } from 'lib/Timeline';
import { DetailedInventoryAsset } from 'components/common/types/DetailedInventoryAsset.types';

import ProhibitionInfo from './ProhibitionInfo';
import { Button as ReadMoreButton } from '../ReadMoreSections';

type ProhibitionsProps = {
  prohibitions?: DetailedInventoryAsset['prohibitions'];
  toggleReadMore?: () => void;
  maxRecordsToShow: number;
};

const Prohibitions = ({
  prohibitions = [],
  toggleReadMore = (): null => null,
  maxRecordsToShow,
}: ProhibitionsProps): React.ReactElement => {
  return (
    <div>
      <h2 className="mb-8 sub-header-base">Prohibitions</h2>
      <div className="pl-2" data-test-id="prohibition-container">
        <Timeline>
          {prohibitions.length ? (
            <ProhibitionInfo prohibitionGroup={prohibitions.slice(0, maxRecordsToShow)} />
          ) : (
            <TimelineItem title={<p className="body-base">{DOUBLE_DASH}</p>} />
          )}
        </Timeline>
        {prohibitions.length > maxRecordsToShow ? <ReadMoreButton onClick={toggleReadMore} /> : null}
      </div>
    </div>
  );
};

export default Prohibitions;
